import api from "lib/api/api";

export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";
export const MARK_NOTIFICATION_AS_SEEN = "MARK_NOTIFICATION_AS_SEEN";

export const fetchNotifications = (studentId) => async (dispatch) => {
  dispatch({ type: FETCH_NOTIFICATIONS_REQUEST });

  try {
    const res = await api.get(`/notifications/student/${studentId}`);

    dispatch({ type: FETCH_NOTIFICATIONS_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({
      type: FETCH_NOTIFICATIONS_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch notifications",
    });
  }
};

export const markNotificationAsSeen = (notificationId,studentId) => async (dispatch) => {
  try {
    await api.put(`/notifications/${notificationId}/seen`);
    dispatch({ type: MARK_NOTIFICATION_AS_SEEN, payload: notificationId });
    dispatch(fetchNotifications(studentId)); // <-- Refetch after marking seen

  } catch (error) {
    console.error("Failed to mark notification as seen", error);
  }
};

export const ADD_NOTIFICATION = "ADD_NOTIFICATION";

export const addNotification = (notification) => ({
  type: ADD_NOTIFICATION,
  payload: notification,
});
